import React from 'react'

import { AIGenerated2, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function Intro() {
  return (
    <div className="conference-sign-in-modal__intro">
      <div className="conference-sign-in-modal__header-group">
        <p className="conference-sign-in-modal__title cgt-heading-300">
          Welcome to CGTrader AI
        </p>
        <p className="conference-sign-in-modal__subtitle cgt-body-md">
          Enter your email to start generating 3D models instantly
        </p>
      </div>
      <ul className="conference-sign-in-modal__benefits">
        <li className="conference-sign-in-modal__benefit cgt-body-md">
          <Icon
            svgComponent={AIGenerated2}
            size={{ width: '20', height: '20' }}
            notSpaced
            className="conference-sign-in-modal__benefit-icon"
          />
          <span>
            Get
            {' '}
            <span className="conference-sign-in-modal__benefit-strong cgt-body-md-semibold">
              5 Free Generations
            </span>
            {' '}
            to try things out
          </span>
        </li>
        <li className="conference-sign-in-modal__benefit cgt-body-md">
          <Icon
            svgComponent={AIGenerated2}
            size={{ width: '20', height: '20' }}
            notSpaced
            className="conference-sign-in-modal__benefit-icon"
          />
          <span>No credit card is required</span>
        </li>
      </ul>
    </div>
  )
}

export default Intro
